import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FooterLink from './FooterLink';
import { exists } from '../Utils/countryItemExists';

const useStyles = makeStyles({
  root: {},
});

export const FooterLinkList = (props) => {
  const { items } = props;

  const classes = useStyles();

  return (
    <Typography className={classes.root}>
      <ul>
        {items.filter(exists).map((item, index) => (
          <li key={index}>
            <FooterLink href={item.link} text={item.text} />
          </li>
        ))}
      </ul>
    </Typography>
  );
};

FooterLinkList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ link: PropTypes.string, text: PropTypes.string })).isRequired,
};

export default FooterLinkList;
